import Swiper from 'swiper';

export default function partnersSlider() {
  // eslint-disable-next-line
  let partnersSlider = new Swiper ('.partners-slider', {
    slidesPerView: 2,
    spaceBetween: 16,
    scrollbar: {
      el: '.partners-scrollbar',
      hide: false,
      draggable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 6,
      },
      1199: {
        slidesPerView: 8,
      },
    },
  });
}



// WEBPACK FOOTER //
// ./scripts/partials/partners-slider.js